var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tinkSlideItem",attrs:{"id":'tinkListItem_' + _vm._uid}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }